import type { DocMigration } from "../docMigration";

function isFoundationDatumEntity(d?: any): boolean {
  return d?.datumType === "FOUNDATION";
}

function isFacadeDatumEntity(d?: any): boolean {
  if (d?.datumType !== "WALL") {
    return false;
  }

  return d.direction === "VERTICAL" || d.direction === "HORIZONTAL";
}

function isLevelDatumEntity(d?: any): boolean {
  return d?.datumType === "LEVEL";
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_408: DocMigration = {
  maxSchemaVersion: "0.0.408",
  description: "Built-in datum groups",
  apply(json: any) {
    const { datums } = json;

    const addToGroup = (entitySufix: string, entityId: string, groupId: string) => {
      const entityGroupKey = `${entitySufix}.${entityId}`;

      // remove from previous group
      if (json.entityGroups[entityGroupKey]) {
        delete json.entityGroups[entityGroupKey];
      }

      // add to the new group
      json.entityGroups = {
        ...json.entityGroups,
        [entityGroupKey]: groupId,
      };
    };

    // create groups
    const legacyFoundationDatumGroup = {
      entityType: "GROUP",
      name: "Foundation",
      id: "legacyFoundationDatumsGroup",
      sortIndex: 0,
      isBuiltIn: true,
    };

    const legacyFacadeDatumGroup = {
      entityType: "GROUP",
      name: "Facade",
      id: "legacyFacadeDatumsGroup",
      sortIndex: 1,
      isBuiltIn: true,
    };

    const legacyLevelDatumGroup = {
      entityType: "GROUP",
      name: "Level",
      id: "legacyLevelDatumsGroup",
      sortIndex: 2,
      isBuiltIn: true,
    };

    json.groups = {
      ...json.groups,
      [legacyFoundationDatumGroup.id]: legacyFoundationDatumGroup,
      [legacyFacadeDatumGroup.id]: legacyFacadeDatumGroup,
      [legacyLevelDatumGroup.id]: legacyLevelDatumGroup,
    };

    // add existing legacy datums to the corresponding group
    for (const datumId in datums) {
      const datum = datums[datumId];

      if (isFoundationDatumEntity(datum)) {
        addToGroup("datum", datum.id, legacyFoundationDatumGroup.id);
      } else if (isFacadeDatumEntity(datum)) {
        addToGroup("datum", datum.id, legacyFacadeDatumGroup.id);
      } else if (isLevelDatumEntity(datum)) {
        addToGroup("datum", datum.id, legacyLevelDatumGroup.id);
      }
    }

    return json;
  },
};

export default migration_0_0_408;
